import { Directive, ViewContainerRef, TemplateRef, OnInit, Input } from '@angular/core';
import { take } from 'rxjs/operators';
import { UserFromLoginDto } from 'src/app/core/models/dto/user-from-login-dto';
import { User } from 'src/app/core/models/user';
import { AuthService } from 'src/app/core/services/auth.service';

@Directive({
    selector: '[appHasRole]',
    standalone: false
})

export class HasRoleDirective {
  @Input() appHasRole: string[] = [];
  user: UserFromLoginDto = {} as UserFromLoginDto;

  constructor(private viewContainerRef: ViewContainerRef, private templateRef: TemplateRef<any>,
    private accountService: AuthService) {
    this.accountService.currentUser$.pipe(take(1)).subscribe({
      next: user => {
        if (user) this.user = user;
      }
    })
  }

  ngOnInit(): void {
    if (this.user?.roleName.some(r => this.appHasRole.includes(r))) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }

}

// export class HasRoleDirective implements OnInit {

//   @Input() appHasRole: string[];
//   isVisible = false;

//   constructor(
//     private viewContainerRef: ViewContainerRef,
//     private templateRef: TemplateRef<any>,
//     private authService: AuthService
//   ) { }

//   ngOnInit() {
//     const userRoles = this.authService.decodeToken.role as Array<string>;
//     // If no roles than clear the ViewContainerRef.
//     if (!userRoles) {
//       this.viewContainerRef.clear();
//     }
//     // If user has the roles than render the element.
//     if (this.authService.roleMatch(this.appHasRole)) {
//       if (!this.isVisible) {
//         this.isVisible = true;
//         this.viewContainerRef.createEmbeddedView(this.templateRef);
//       } else {
//         this.isVisible = false;
//         this.viewContainerRef.clear();
//       }
//     }
//   }

// }
